import {isServer} from '../utils/utils'
import useMultiSite from '../hooks/use-multi-site'
import {useEffect, useMemo, useState} from 'react'

/**
 * @return {{necessary: boolean, preferences: boolean, statistics: boolean, marketing: boolean}}
 */
export const useCookieConsent = () => {
    const {site} = useMultiSite()
    const enableCookiebot = site?.gdpr?.enableCookiebot || false

    // keep track of the last consent change timestamp to recalculate the consent object
    const [lastConsentChange, setLastConsentChange] = useState(null)

    // watch for consent changes and update the lastConsentChange timestamp to force a re-render
    useEffect(() => {
        if (enableCookiebot) {
            window.addEventListener(
                'CookiebotOnAccept',
                (event) => {
                    setLastConsentChange(event.timeStamp || Date.now())
                },
                false
            )
            return () => {
                window.removeEventListener('CookiebotOnAccept', () => {}, false)
            }
        }
    }, [enableCookiebot])

    const consent = useMemo(
        () =>
            enableCookiebot
                ? {...(isServer ? {} : window.Cookiebot)?.consent, lastConsentChange}
                : {
                      lastConsentChange,
                      necessary: true,
                      preferences: true,
                      statistics: true,
                      marketing: true
                  },
        [enableCookiebot, lastConsentChange]
    )
    return consent
}
